module.exports = __webpack_public_path__ + "img/07.3b2a3701.png";